import * as types from "../constants/logsConstants";
import axios from "axios";
import { getKeycloackToken } from "./auth";
import { notify } from "./snack";
import qs from "qs";
import moment from "moment";

export const getAutomationBuildLogs = (skillId, opt) => async (dispatch) => {
  try {
    let token = await getKeycloackToken();
    let filters = qs.stringify(opt.filters || {});

    let dateQuery = "";
    let _url;
    if (moment(opt?.startDate).isValid() && moment(opt?.endDate).isValid()) {
      dateQuery = `&startDate=${opt.startDate}&endDate=${opt.endDate}`;
    }
    if (dateQuery) {
      _url = `${
        process.env.REACT_APP_BOT_SERVICE_URL
      }/draftSkills/automationBuildLogs/${skillId}?page=${
        opt?.page || 1
      }&pageSize=${opt?.pageSize || 100}&${filters}&${dateQuery}`;
    } else {
      _url = `${
        process.env.REACT_APP_BOT_SERVICE_URL
      }/draftSkills/automationBuildLogs/${skillId}?text=${
        opt.text ? opt.text : ""
      }&${filters}`;
    }

    var config = {
      method: "get",
      headers: {
        Authorization: `Bearer ${token}`,
      },
      url: _url,
    };
    const result = await axios(config);

    dispatch({
      type: types.AUTOMATION_BUILD_LOGS,
      payload: result.data.data,
      total: result?.data?.pagination?.total,
    });
    return result?.data?.data;
  } catch (err) {
    dispatch(notify("error", "Failed to  Draft Skill: " + err.toString()));
  }
};

export const getAutomationBuild = (skillId) => async (dispatch) => {
  try {
    let token = await getKeycloackToken();
    var config = {
      method: "get",
      headers: {
        Authorization: `Bearer ${token}`,
      },
      url: `${process.env.REACT_APP_BOT_SERVICE_URL}/draftSkills/automationBuildLogs/get/${skillId}`,
    };
    const result = await axios(config);

    dispatch({
      type: types.AUTOMATION_BUILD_LOG,
      payload: result.data.data,
    });
  } catch (err) {
    dispatch(notify("error", "Failed to  Draft Skill: " + err.toString()));
  }
};
